import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { useReleasePurchaseFormContext } from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/ReleasesPurchaseProvider';
import { Col, Form, Row, Select, Typography } from 'antd';
import { useIntl } from 'react-intl';

interface Props {
  enable: (cstIcmsParam: string[], csosnIcmsParam?: string[]) => boolean;
}

const IcmsStFields: React.FC<Props> = ({ enable }) => {
  const intl = useIntl();
  const { Title } = Typography;
  const { purchase } = useReleasePurchaseFormContext();

  return (
    <Form.Item shouldUpdate noStyle>
      {() => {
        return (
          <>
            <Row gutter={[12, 12]}>
              <Col span={24} lg={24}>
                <Title level={3} style={{ padding: 0 }}>
                  {intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icmsSt.taxRegime',
                  })}
                </Title>
              </Col>

              <Col span={24} lg={8}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'modBcIcmsSt']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt',
                  })}
                >
                  <Select
                    disabled={
                      !enable(
                        ['10', '30', '70', '90'],
                        ['201', '202', '203', '900'],
                      ) || purchase?.boschMigration
                    }
                    allowClear
                    style={{ width: '100' }}
                    options={[
                      {
                        value: 0,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt.zero',
                        }),
                      },
                      {
                        value: 1,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt.one',
                        }),
                      },
                      {
                        value: 2,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt.two',
                        }),
                      },
                      {
                        value: 3,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt.three',
                        }),
                      },
                      {
                        value: 4,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt.four',
                        }),
                      },
                      {
                        value: 5,
                        label: intl.formatMessage({
                          id: 'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt.five',
                        }),
                      },
                    ]}
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} lg={4} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'reductionIcmsSt']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icmsSt.taxRegime.reductionIcmsSt',
                  })}
                >
                  <InputDecimal
                    disabled={
                      !enable(
                        ['10', '30', '70', '90'],
                        ['201', '202', '203', '900'],
                      ) || purchase?.boschMigration
                    }
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} lg={4} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'baseIcmsSt']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icmsSt.taxRegime.baseIcmsSt',
                  })}
                >
                  <InputDecimal
                    disabled={
                      !enable(
                        ['10', '30', '70', '90'],
                        ['201', '202', '203', '900'],
                      ) || purchase?.boschMigration
                    }
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} lg={4} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'quotaIcmsSt']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icmsSt.taxRegime.quotaIcmsSt',
                  })}
                >
                  <InputDecimal
                    disabled={
                      !enable(
                        ['10', '30', '70', '90'],
                        ['201', '202', '203', '900'],
                      ) || purchase?.boschMigration
                    }
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} lg={4} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'valueIcmsSt']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icmsSt.taxRegime.valueIcmsSt',
                  })}
                  initialValue={0}
                >
                  <InputDecimal
                    disabled={
                      !enable(
                        ['10', '30', '70', '90'],
                        ['201', '202', '203', '900'],
                      ) || purchase?.boschMigration
                    }
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} lg={4} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'quotaMvaSt']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icmsSt.taxRegime.quotaMvaSt',
                  })}
                >
                  <InputDecimal
                    disabled={
                      !enable(
                        ['10', '30', '70', '90'],
                        ['201', '202', '203', '900'],
                      ) || purchase?.boschMigration
                    }
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} lg={4} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'baseIcmsStWithheld']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icmsSt.taxRegime.baseIcmsStWithheld',
                  })}
                >
                  <InputDecimal
                    disabled={
                      !enable(['60'], ['500']) || purchase?.boschMigration
                    }
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} lg={4} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'valueIcmsStWithheld']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icmsSt.taxRegime.valueIcmsStWithheld',
                  })}
                >
                  <InputDecimal
                    disabled={
                      !enable(['60'], ['500']) || purchase?.boschMigration
                    }
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} lg={4} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'baseFcpSt']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icmsSt.taxRegime.baseFcpSt',
                  })}
                >
                  <InputDecimal
                    disabled={
                      !enable(['10', '30', '60', '70', '90']) ||
                      purchase?.boschMigration
                    }
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} lg={4} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'quotaFcpSt']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icmsSt.taxRegime.quotaFcpSt',
                  })}
                >
                  <InputDecimal
                    disabled={
                      !enable(['10', '30', '60', '70', '90']) ||
                      purchase?.boschMigration
                    }
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} lg={4} md={12}>
                <FloatingFormItem
                  name={['purchaseItemTaxes', 'valueFcpSt']}
                  label={intl.formatMessage({
                    id: 'purchases.details.itemsPurchase.icmsSt.taxRegime.valueFcpSt',
                  })}
                >
                  <InputDecimal
                    disabled={
                      !enable(['10', '30', '60', '70', '90']) ||
                      purchase?.boschMigration
                    }
                  />
                </FloatingFormItem>
              </Col>
            </Row>
          </>
        );
      }}
    </Form.Item>
  );
};

export default IcmsStFields;
